import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import "../style/SensorMenuOverlay.css";

export default function EditSensorModal({ open, onClose, sensor, onEdit }) {
    const [nombre, setNombre] = useState("");
    const [tipoSensor, setTipoSensor] = useState("");
    const [valorMinimo, setValorMinimo] = useState("");
    const [valorMaximo, setValorMaximo] = useState("");
    const [conexion, setConexion] = useState("Wi-Fi");
    const [terreno, setTerreno] = useState("");
    const [terrenosDisponibles, setTerrenosDisponibles] = useState([]);

    const TIPOS_SENSOR = ["temperatura", "humedad", "luz", "ph"];

    useEffect(() => {
        const fetchTerrenos = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await fetch("https://agro-nexus-prod.vercel.app/api/usuario/terrenos", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = await res.json();
                if (data.success) {
                    setTerrenosDisponibles(data.terrenos);
                }
            } catch (err) {
                console.error("❌ Error cargando terrenos:", err);
            }
        };
        fetchTerrenos();
    }, []);

    useEffect(() => {
        if (sensor) {
            setNombre(sensor.sensor || "");
            setTipoSensor(sensor.tipo_sensor || "");
            setValorMinimo(sensor.valor_minimo || "");
            setValorMaximo(sensor.valor_maximo || "");
            setTerreno(sensor.terreno || "");
            setConexion(sensor.conexion || "Wi-Fi");
        }
    }, [sensor]);

    if (!open || !sensor) return null;

    const handleSave = async () => {
        try {
            const token = localStorage.getItem("token");

            const body = {
                sensor_id: sensor.sensor_id,
                nombre: nombre || sensor.sensor,
                tipo_sensor: tipoSensor || sensor.tipo_sensor,
                valor_minimo: valorMinimo || sensor.valor_minimo,
                valor_maximo: valorMaximo || sensor.valor_maximo,
                terreno: terreno || sensor.terreno,
                conexion,
            };

            const res = await fetch(`https://agro-nexus-prod.vercel.app/api/sensores/${sensor.sensor_id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            });

            const data = await res.json();

            if (res.ok) {
                alert("✅ Sensor actualizado correctamente");
                onEdit();
                onClose();
            } else {
                alert(`⚠️ Error: ${data.message}`);
            }
        } catch (error) {
            console.error("❌ Error actualizando sensor:", error);
            alert("Error actualizando el sensor.");
        }
    };


    const otrosTerrenos = terrenosDisponibles.filter(
        (t) => t.nombre !== terreno
    );

    return (
        <div className="edit-overlay">
            <div className="edit-box">
                <div className="edit-header">
                    <h2>Editar Sensor</h2>
                    <button className="edit-close-btn" onClick={onClose}>
                        <X />
                    </button>
                </div>

                <div className="edit-form">
                    <input
                        type="text"
                        placeholder="Nombre del Sensor"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                    />

                    <select value={tipoSensor} onChange={(e) => setTipoSensor(e.target.value)}>
                        <option value="">Seleccionar tipo</option>
                        {TIPOS_SENSOR.map((t) => (
                            <option key={t} value={t}>
                                {t}
                            </option>
                        ))}
                    </select>

                    <input
                        type="number"
                        placeholder="Valor Mínimo"
                        value={valorMinimo}
                        onChange={(e) => setValorMinimo(e.target.value)}
                    />
                    <input
                        type="number"
                        placeholder="Valor Máximo"
                        value={valorMaximo}
                        onChange={(e) => setValorMaximo(e.target.value)}
                    />

                    <select value={terreno} onChange={(e) => setTerreno(e.target.value)}>
                        {terreno && (
                            <option value={terreno}>
                                {terreno} (actual)
                            </option>
                        )}
                        {otrosTerrenos.map((t) => (
                            <option key={t.id} value={t.nombre}>
                                {t.nombre}
                            </option>
                        ))}
                    </select>

                    <select value={conexion} onChange={(e) => setConexion(e.target.value)}>
                        <option value="Wi-Fi">Wi-Fi</option>
                        <option value="Bluetooth">Bluetooth</option>
                        <option value="Cable">Cable</option>
                        <option value="LoRa">LoRa</option>
                    </select>
                </div>

                <div className="edit-actions">
                    <button className="btn-cancel" onClick={onClose}>
                        Cancelar
                    </button>
                    <button className="btn-primary" onClick={handleSave}>
                        Guardar Cambios
                    </button>
                </div>
            </div>
        </div>
    );
}
